export class ComProductCollectAmountModel {
    public businessProductId?:number;
    public collectAmountGroupId?:number;
    public collectAmountId?:number;
    public dealerId?:number;
    public employeeJobId?:number;
    public paymentId?:number;
    public productosCOEId?:number;
    
    public activeId?:boolean;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}